import { combineReducers } from 'redux';
import userAccountsReducer from './accounts';


const userReducer = combineReducers({
	accounts: userAccountsReducer,
});

export default userReducer;